var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleArrowOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7929 3.5C13.2383 3.5 13.4614 4.03857 13.1464 4.35355L7.35355 10.1464C7.15829 10.3417 6.84171 10.3417 6.64645 10.1464L0.853553 4.35355C0.53857 4.03857 0.761654 3.5 1.20711 3.5L7 3.5L12.7929 3.5Z",
    fill: "#899AA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleArrowOpen);
export default __webpack_public_path__ + "static/media/triangle_arrow_open.b03d0804167f8f0f021b690ec3e754b1.svg";
export { ForwardRef as ReactComponent };